module.exports = __webpack_public_path__ + "static/media/header.e6209b0f.jpg";